export default __webpack_public_path__ + "static/media/image.ce7148eb.png";